var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25083 11.5V8.79049C6.25083 8.48209 6.27063 8.18046 6.31023 7.88562C6.34983 7.58739 6.40264 7.27221 6.46865 6.94009H7.57096C7.63696 7.27221 7.68757 7.58739 7.72277 7.88562C7.76238 8.18046 7.78218 8.48209 7.78218 8.79049V11.5H6.25083ZM6 5.26253C6 5.15408 6.0242 5.0541 6.07261 4.9626C6.12541 4.86771 6.19582 4.78637 6.28383 4.71859C6.37184 4.65081 6.47745 4.59828 6.60066 4.561C6.72387 4.52033 6.85589 4.5 6.9967 4.5C7.13311 4.5 7.26293 4.52033 7.38614 4.561C7.50935 4.59828 7.61496 4.65081 7.70297 4.71859C7.79538 4.78637 7.86799 4.86771 7.92079 4.9626C7.9736 5.0541 8 5.15408 8 5.26253C8 5.37098 7.9736 5.47265 7.92079 5.56754C7.86799 5.65904 7.79538 5.73868 7.70297 5.80646C7.61496 5.87424 7.50935 5.92847 7.38614 5.96914C7.26293 6.0098 7.13311 6.03014 6.9967 6.03014C6.85589 6.03014 6.72387 6.0098 6.60066 5.96914C6.47745 5.92847 6.37184 5.87424 6.28383 5.80646C6.19582 5.73868 6.12541 5.65904 6.07261 5.56754C6.0242 5.47265 6 5.37098 6 5.26253Z",
    fill: "#051D42"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.5,
    r: 6.5,
    stroke: "#051D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.41e0e2ed235d97a6ff9bdfd3782f6f89.svg";
export { ForwardRef as ReactComponent };